import { ApplicationConfig, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding, withRouterConfig } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { authInterceptor } from '@app/interceptors/auth.interceptor';
import { delaiInterceptor } from '@app/interceptors/delai.interceptor';
import { dossierInterceptor } from '@shared/interceptors/dossier.interceptor';
import { erreurInterceptor } from '@shared/interceptors/erreur.interceptor';

/**
 * Configuration de l'application : routes, appels HTTP et leurs intercepteurs, langue française.
 * Angular Material et ng2-charts ne sont plus fournis : aucun écran ne s'en sert (dates : ui/saisie-date et
 * ui/calendrier ; graphique : ui/graphique-evolution en SVG).
 */
export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    // Navigation en échec : promesse résolue à false (pas d'erreur non traitée), écran d'erreur affiché par
    // app-navigation-etat (core/navigation-etat.ts).
    provideRouter(routes, withComponentInputBinding(), withRouterConfig({ resolveNavigationPromiseOnError: true })),
    provideHttpClient(
      withInterceptors([
        authInterceptor,
        // En-têtes du dossier courant (X-DOSSIER, X-CABINET du client, mode archive).
        dossierInterceptor,
        erreurInterceptor,
        // En dernier (au plus près du réseau) : délai maximal des appels, erreur vue par les autres intercepteurs.
        delaiInterceptor,
      ]),
    ),
    { provide: LOCALE_ID, useValue: 'fr-FR' },
  ],
};
